<template>
  <div>
    <!-- 用户资产变更-->
    <div class="detail-wrap">
      <el-form ref="editForm" :model="formData">
        <div class="d-header">
          <div class="fl">
            <i class="el-icon-info" />
            申请单号：<span v-if="formData.billNo" style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{formData.billNo}}</span>
            <span v-else class="information"> 待生成</span>
            <!-- 状态 -->
            <span v-if="!dataId" class="information"> 新增</span>
            <span v-else class="information">

              {{
                formData.stat == '0' ? '制单' : formData.stat == '1' ? '制单' : formData.stat == '2' ? '审核中' : formData.stat ==
                '5' ? '已审核' : formData.stat == '6' ? '驳回' : formData.stat == '99' ? '取消' : '取消'
              }}</span>

          </div>
          <div class="fr" v-show="btn_no">
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="editButton && (formData.stat == 1 || formData.stat == 6)"
                       @click="saveData">保存
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&(formData.stat==1)&&!formData.processId&&submitButton"
                       @click="showCloseDialog = true;type='提交'">提交
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                       v-if="formData.id!=null&&formData.stat == 2&&!formData.processId&&checkButton"
                       @click="doCheck">审核
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-bottom"
                       v-if="formData.id!=null&&formData.stat == 2&&!formData.processId&&rejectButton"
                       @click="showCloseDialog = true;type='驳回'">驳回
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-close"
                       v-if="formData.id!=null&&(formData.stat==1||formData.stat==6)&&!formData.processId&&cancelButton"
                       @click="showCloseDialog = true;type='取消'">取消
            </el-button>
          </div>
        </div>

        <div>

          <!-- 基本信息 -->
          <div style="overflow: unset!important;
            overflow-y: scroll!important;
            height: 100vh!important;display: block ">
            <div class="d-cont edit-mce-box">
              <div class="d-item">
                <div class="title first"><b>主信息</b></div>
                <table class="table-detail">
                  <tbody>
                  <tr>

                    <th>
                      <em class="f-red">申请人部门</em>
                    </th>
                    <td>
                      <el-input placeholder="请选择" v-model="formData.orgName" readonly>
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="assignOrg"></i>
                      </el-input>
                    </td>

                    <th>
                      <em class="f-red">申请人</em></th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.createBy" :disabled="true" clearable />
                    </td>
                    <th>
                      <em class="f-red">联系电话</em></th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.createrMobile"
                        clearable />

                    </td>
                    <th>审核结果</th>
                    <td v-if="formData.resultStat == 1">通过</td>
                    <td v-else-if="formData.resultStat == 2">不通过</td>
                    <td v-else></td>

                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-item">
                <div class="title first"><b>申请信息</b></div>
                <table class="table-detail">
                  <tbody>
                  <tr>
                    <th>
                      关联工单
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.orderNo" :readonly="true" clearable>
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="showPreconditionDialogFunc"></i>
                      </el-input>
                    </td>
                    <th>
                      服务类型
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.serviceTypeName" :disabled="true" clearable />
                    </td>
                    <th>
                      用户姓名
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.userName" :disabled="true" clearable />
                    </td>
                    <th>
                      用户电话
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.userMobile" :disabled="true" clearable />
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <em class="f-red">档案号</em>
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.profileNo" :readonly="true" clearable>
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="showProfileDialogFunc"></i>
                      </el-input>
                    </td>
                    <th>
                      <em class="f-red">产品条码</em>
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.barcode" :readonly="true"
                                :disabled="!formData.profileId" clearable>
                        <i v-if="formData.profileId" slot="suffix" class="el-input__icon el-icon-search" @click="showAssetDialogFunc"></i>
                      </el-input>
                    </td>
                    <th>
                      产品名称
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.itemName" :disabled="true" clearable />
                    </td>
                    <th>
                      产品分类
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.bigCategoryName" :disabled="true" clearable />
                    </td>
                  </tr>
                  <tr>
                    <th>
                      申请类型
                    </th>
                    <td>
                      <el-select v-model="applyType">
                        <el-option label="转移" :value="1"/>
                        <el-option label="失效" :value="2"/>
                      </el-select>
                    </td>
                    <th>
                      转移的档案号
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.transferProfileNo" readonly
                                v-bind:disabled="applyType===2" clearable>
                        <i slot="suffix" class="el-input__icon el-icon-search"
                           @click="() => { if (applyType!==2) {showCustProfile = true} }"></i>
                      </el-input>
                    </td>
                    <th>
                      申请原因
                    </th>
                    <td colspan="3" style="position: relative;">
                      <el-input type="text" autocomplete="off" v-model="formData.transferReason" clearable >
                      </el-input>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div class="d-item">
                <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;align-items: center;">
                  <div class="title first"><b>附件列表</b></div>
                  <el-upload style="display:flex; float: right"
                             class="upload-demo"
                             ref="upload"
                             :action="api.uploadFileUrl"
                             :show-file-list="false"
                             :on-success="(res,file, fileList) => {handleFileSuccess(res,file, fileList)}"
                             :on-progress="upVideo"
                             :headers="headers"
                             :auto-upload="true"
                  >
                    <el-button type="primary" class="button-sty btn_zdy">
                      <i class="el-icon-plus"></i>
                      附件
                    </el-button>
                  </el-upload>
                </div>
                <div>
                  <vxe-table style="margin-top: 0px;" :stripe="true"
                             :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                             :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                             show-overflow height="210" :column-config="{ resizable: true }" @checkbox-change="selectChangeEvent"
                             @checkbox-all="selectChangeEvent" :data="fileList">
                    <vxe-column type="checkbox" width="40" />
                    <vxe-column field="fileName" title="附件名称" width="400">
                      <template #default="{row}">
                        <!-- <a :href="row.fileUrl" :download="row.name">{{row.fileName}}</a> -->
                        <span @click="openVideo(row.fileUrl)">{{ row.fileName }}</span>

                      </template>
                    </vxe-column>
                    <vxe-column title="操作" width="90">
                      <template #default="{row}">
                        <div >
                          <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                                      popper-class="tooltip-skin">
                            <i @click="deleteFile(row)" class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>
                          </el-tooltip>

                          <el-tooltip :enterable="false" effect="dark" content="下载" placement="top"
                                      popper-class="tooltip-skin">
                            <i @click="handleDownload(row.fileName, row.fileUrl)" class="el-icon-download"
                               style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>
                          </el-tooltip>

                          <el-tooltip :enterable="false" effect="dark" content="预览文件" placement="top"
                                      popper-class="tooltip-skin">
                            <i @click="openVideo(row.fileUrl)" class="el-icon-view"
                               style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>
                          </el-tooltip>
                        </div>
                      </template>
                    </vxe-column>
                  </vxe-table>
                </div>
              </div>
              <wfView  visible-key="showEdit" :wfData="wfData" :parent-target="_self" :key="wfKey"
                       @reloadWf="reloadWf" @reload="$reloadHandle"></wfView>

              <div style="height:250px"></div>
            </div>

          </div>

        </div>


      </el-form>
      <!-- 服务区域弹窗表 -->
    </div>
    <sitePop v-if="showSitePop" @commit="siteCommit" :visiable.sync="showSitePop" :orgId="formData.orgId" multi="true" />

    <orderPop v-if="showOrderPop" @commit="orderCommit" :visiable.sync="showOrderPop"
              multi="true" />

    <profilePop v-if="showProfilePop" @commit="profileCommit" :visiable.sync="showProfilePop"
              multi="true" />

    <assetPop v-if="showAssetPop" :profileId="formData.profileId" @commit="assetCommit" :visiable.sync="showAssetPop"
                multi="true" />

    <custProfileDialog v-if="showCustProfile" @commit="custProfileCommit" :visiable.sync="showCustProfile"
                       multi="true" />

    <auditDialog v-if="showAuditDialog" :form-data="formData" :shippingMethodList="shippingMethodList" @closeD="closeD"
                 :visiable.sync="showAuditDialog" multi="true" @goBackIndex="goBackIndex" />

    <closeDialog v-if="showCloseDialog"
                 :dataId="formData.id"
                 :confirmNo="formData.billNo"
                 :type="type"
                 @closeD="closeD"
                 :visiable.sync="showCloseDialog"
                 multi="true"
                 @goBackIndex="goBackIndex"
    />
    <!-- 文件预览 -->
    <Preview v-if="showPreview" @closeD="closeD2" :visiable.sync="showPreview" :imgVisbleURL="imgVisbleURL" />
    <UserOrgDialog v-if="showOrgDialog" @commitOrgSelect="commitOrgSelect" :visiable.sync="showOrgDialog"
                   :userId="this.userId" multi="true" />
    <checkDialog v-if="showCheckDialog" @commit="checkCommit" :visiable.sync="showCheckDialog" :dataId="this.formData.id"
                 :billNo="this.formData.billNo" multi="true" />

  </div>
</template>

<script>
import store from "@/store";
import api from "@/api/projectApi";
import { echoFileFormat, uploadFileFormat } from "@/util/uploadFormat";
import sitePop from '@/views/dialogCommon/radioSiteDialog.vue'
import orderPop from '@/views/dialogCommon/radioAssetOrderDialog.vue'
import profilePop from '@/views/dialogCommon/radioUserProfileDialog.vue'
import assetPop from '@/views/dialogCommon/radioUserAssetDialog.vue'
import custProfileDialog from '@/views/dialogCommon/custProfileListDialog.vue'
import checkDialog from './check.vue'
//import auditDialog from "./auditDialog.vue";
import closeDialog from "./closeDialog.vue";

import { mapGetters } from "vuex";
import {siteMixins} from "@/mixins/tabChang";
// 流程
import wfView from "@/views/dialogCommon/wfMsgDialog.vue";
// 视频
import videoUpload from "@/components/formItem/videoUpload.vue"
// 文件预览
import Preview from "@/views/dialogCommon/PreviewDialog.vue";
import UserOrgDialog from "@/views/dialogCommon/radioUserOrgDialog.vue";

export default {
  mixins: [siteMixins],
  inject: ['reload'],
  name: 'editTransfer',
  props: {
    _dataId: [String, Number],
    processId: [String, Number],
    btn_no: {
      type: Boolean,
      default: true
    },
    type: String
  },
  components: {Preview,videoUpload, wfView,orderPop, profilePop,sitePop,assetPop,closeDialog,
    custProfileDialog,UserOrgDialog,checkDialog},
  data() {
    return {
      // 查询参数
      queryParams: {
        deptName: ""
      },
      imgVisbleURL: '',

      showPreview: false,

      fileList: [],

      wfKey:0,
      btn_no:true,
      userId:null,
      applyType:1,

      editButton: false,
      processId: '',
      showEdit: false,

      wfData:{
        wfEntityId:''
      },
      reportPartsList: [],
      showPartsDialog: false,
      showPreconditionDialog: false,

      dictTypesReportType: [],
      dictTypesGasType: [],

      productOptions0: [],
      productOptions1: [],

      gasTypeObj: {},
      reportTypeObj: {},

      warehouseType: 0,
      justShow: false,
      showSitePop: false,
      showOrderPop: false,
      showProfilePop:false,
      showAssetPop:false,
      showCustProfile: false,
      showAuditDialog: false,
      showCloseDialog: false,
      //部门/机构弹框
      showOrgDialog: false,
      showCheckDialog:false,
      isCancel: false,
      selectedData: [],
      shippingMethodList: [],
      logisticsCompaniesList: [],
      picList1: [],
      picList2: [],
      picList3: [],
      showPhotoList: [],
      formData: {
        vedioUrl:'',
        billNo: null, //变更单号;前缀"AT"+年月日+6位流水号
        stat: 1, //单据状态:1制单;2审核中;5已审核;6驳回;99取消
        applyType:1,
        createrMobile:null,
        orderId: null, //工单id，关联so_order.id
        orderNo: null, //工单号，冗余字段
        orgId: null, //部门ID，关联脚手架机构表sys_dept.dept_id
        orgName: null, //部门名称,冗余字段
        orgIdPath: null, //部门ID路径,冗余字段.重要
        userName: null, //用户姓名
        userMobile: null, //用户电话
        itemId: null, //产品Id,关联bas_item.id
        itemCode: null, //产品编码,冗余字段
        itemName: null, //产品名称,冗余字段
        bigCategoryId: null, //产品大类ID,关联bas_item_category.id
        bigCategoryName: null, //产品大类名称。冗余字段
        serviceTypeId: null,
        serviceTypeName: null,
        barcode: null, //产品条码
        profileId: null, //用户档案Id,关联bas_cust_profile.id
        profileNo: '',
        useStat: null, //
        transferProfileId: null, //
        transferProfileNo: null, //
        transferReason: null, //
        createBy:null,
        partsList: [],
        fileList: [],
      },

      show3: false,
      node: true,

      isEdit: false,
      tabIndex: 'first',
      dataId: '',


    };
  },
  computed: {
    ...mapGetters(["permissions"]),
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    }


  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    if (this.btn_no) this.btn_no = this.btn_no;

    this.userId = store.getters.userInfo.id;
    if (this.processId && !isNaN(this.processId)) this.wfData.wfEntityId = this.processId;
    this.editButton = this.permissions["wkAssetTransferEdit"];
    this.submitButton= this.permissions["wkAssetTransferSubmit"]; //提交
    this.checkButton= this.permissions["wkAssetTransferCheck"]; //审核
    this.rejectButton= this.permissions["wkAssetTransferReject"]; //驳回
    this.cancelButton= this.permissions["wkAssetTransferCancel"]; //取消
  },
  mounted() {
    this.getData()
  },
  watch: {


  },
  methods: {
    closeD2() {
      this.showPreview = false

    },
    // 文件下载
    handleDownload(Vname, Vurl) {
      console.log(Vname, Vurl, "文件下载");
      // let url=file.type
      let url = Vurl
      let name = Vname

      const x = new XMLHttpRequest()
      x.open('GET', url, true)
      x.responseType = 'blob'
      x.onload = function () {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.download = name
        a.click()
      }
      x.send()


      // window.open(url,'_blank');
    },
    // 文件预览
    openVideo(value) {
      this.imgVisbleURL = value
      this.showPreview = true
    },
    reloadWf(){
      console.log('保存前的刷新');
      //this.$emit('editViewDataUpdate')
      this.getData()
      this.wfKey +=1
    },
    upVideo(){
      this.$mask.open()

    },
    handleFileSuccess(res, file, fileList) {


      let url = res.data.url
      let fileName = file.name
      console.log(url, "url")
      console.log(fileName, "name")
      this.fileList.push({
        fileName: fileName,
        fileUrl: url
      })
      this.$message({
        message: '附件上传成功',
        type: 'success'
      });
      this.$mask.close()
    },
    deleteFile(row) {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        console.log(row, 'delete')
        this.fileList = this.fileList.filter(item => item.url !== row.url)
      })
    },

    //点击选择部门
    assignOrg() {
      this.showOrgDialog = true
    },
    commitOrgSelect(data) {
      this.formData.orgId = data.orgId;
      this.formData.orgName = data.orgName;
      this.formData.orgIdPath = data.orgIdPath;
    },

    // 返回列表页
    goBackIndex() {
      this.$emit('goBackIndex')
    },

    // 抽屉关闭
    closeD() {
      this.showAuditDialog = false
      this.showCloseDialog = false
      this.getData();
    },

    selectChangeEvent(data) {
      console.log('选中数据', data)
      this.selectedData = data.records
    },

    // 工单弹框选中
    orderCommit(data) {
      console.log('选中的工单', data)
      this.formData.orderId = data.orderId
      this.formData.orderNo = data.orderNo
      this.formData.serviceTypeName = data.serviceTypeName
      this.formData.serviceTypeId = data.serviceTypeId
      this.formData.userName = data.userName
      this.formData.userMobile = data.userMobile
      this.formData.itemId = data.itemId
      this.formData.itemCode = data.itemCode
      this.formData.itemName = data.itemName
      this.formData.bigCategoryId = data.bigCategoryId
      this.formData.bigCategoryName = data.bigCategoryName
      this.formData.profileId = data.profileId
      this.formData.profileNo = data.profileNo
      this.formData.barcode = data.barcode
      this.formData.useStat = data.useStat
    },

    profileCommit(data){
      console.log('选中的用户档案', data)
      this.formData.userName = data.userName
      this.formData.userMobile = data.userMobile
      this.formData.profileId = data.profileId
      this.formData.profileNo = data.profileNo
    },

    assetCommit(data){
      console.log('选中的用户资产', data)
      this.formData.itemId = data.itemId
      this.formData.itemCode = data.itemCode
      this.formData.itemName = data.itemName
      this.formData.bigCategoryId = data.bigCategoryId
      this.formData.bigCategoryName = data.bigCategoryName
      this.formData.barcode = data.barcode
      this.formData.useStat = data.useStat
    },

    // 用户档案弹框选中
    custProfileCommit(data) {
      console.log('选中的用户', data)
      this.formData.transferProfileId = data.id
      this.formData.transferProfileNo = data.profileNo
    },

    // 网点弹框选中
    siteCommit(data) {
      console.log('选中的网点', data)
      this.formData.siteId = data.id
      this.formData.siteName = data.name
      this.formData.orgId = data.orgId
      this.formData.orgName = data.orgName
      this.formData.orgIdPath = data.orgIdPath
    },

    saveData() {
      console.log(" this.formData.orgName-->", this.formData.orgName)

      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            this.$mask.open()
            this.formData.applyType = this.applyType
            this.formData.fileList=this.fileList

            var url = (this.isEdit ? api.wkAssetTransfer.updateDataUrl : api.wkAssetTransfer.addDataUrl);
            var method = (this.isEdit ? "put" : "post");
            this.$http({
              url: url,
              method: method,
              data: this.formData,
              isLoading: true,
            }).then(response => {
              this.$message.success("保存成功！");
              this.reload()
              this.$mask.close()

              // this.$emit('editViewDataUpdate')
              // this.$baseReload()
            }).catch(() => {
              this.$message.error("保存失败！");
              this.$mask.close()
            });;
          });
        }
      });
    },

    getData() {
      // console.log('getData')
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.wkAssetTransfer.getDataUrl + this.dataId,
          method: 'get',
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          let data = response.data.data
          if (data.partsList === null || data.partsList === undefined) {
            data.partsList = []
          }
          if (data.fileList === null || data.fileList === undefined) {
            data.fileList = []
          }
          this.formData = data
          this.applyType = this.formData.applyType

          this.fileList=this.formData.fileList

        })
      } else { //新建
        this.enabled = true;
        this.formData.createBy = store.getters.userInfo.name;
        this.formData.createrMobile = store.getters.userInfo.phone;
        this.loadUserOrg1();
      }
    },
    loadUserOrg1() {
      this.$http({
        url: api.wkAssetTransfer.getUserOrgUrl,
        method: 'post',
        data: {}
      }).then(res => {
        console.log("111信息",res.data)
        if(res.data.data.userId != null){
          this.formData.orgId = res.data.data.orgId
          this.formData.orgName = res.data.data.orgName
          this.formData.orgIdPath = res.data.data.orgIdPath

        }
      })
    },
    handleImageChange(fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    handleRemove1() {
      this.picList1 = []
    },
    handleSuccess1(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList1 = echoFileFormat(res.data.url)
    },
    handleRemove2() {
      this.picList1 = []
    },
    handleSuccess2(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList2 = echoFileFormat(res.data.url)
    },
    handleRemove3() {
      this.picList3 = []
    },
    handleSuccess3(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList3 = echoFileFormat(res.data.url)
    },


    handleClick(tab, event) {
      console.log(tab, event);
      console.log(tab.name, "name得值");
      if (tab.index == 0) {
        this.card = true
      } else {
        this.card = false
      }


    },

    areaconfirm(rows) {
      if (rows.length > 0) {

        const tableData = this.table_area;
        const map = {};
        tableData.forEach(function (item) {
          map[item.preconditionId] = 1;
        });
        var items = [];
        rows.forEach((row, index) => {
          const item = {
            preconditionId: row.id,
            areaName: row.precondition
          };
          if (!map[item.preconditionId]) {
            items.push(item);
          }
        });
        this.table_area = this.table_area.concat(items);
      }
    },
    preconditionconfirm(rows) {
      if (rows.length > 0) {

        const tableData = this.table_type;
        const map = {};
        tableData.forEach(function (item) {
          map[item.preconditionId] = 1;
        });
        var items = [];
        rows.forEach((row, index) => {
          const item = {
            preconditionId: row.id,
            typeName: row.precondition
          };
          if (!map[item.preconditionId]) {
            items.push(item);
          }
        });
        this.table_type = this.table_type.concat(items);
      }
    },
    // 删除所选的数据  2表
    handleDelete1_2(index) {
      this.tenant.snCompanyOrderAttributeDTOS.splice(index, 1);
    },
    AddListRow1_2() {

      this.tenant.snCompanyOrderAttributeDTOS.push({})
    },
    // 上传成功
    handleSuccess(response, file) {
      // 上传成功后，隐藏上传按钮
      this.upload_btn = true;
      // this.tenant.snCompanyBrandDTOS[picIndex].pic = res.data.url;
      // Vue.set(this.tenant.shopPhoto, 'pic', res.data.url)

    },
    handleRemove(response, file) {
      // 上传成功后，显示上传按钮
      this.upload_btn = false;
    },

    // 上传成功
    handleSuccess4(res, file, picIndex) {
      // 上传成功后，隐藏上传按钮
      this.upload_btn4 = true;
      // this.tenant.snCompanyBrandDTOS[picIndex].pic = res.data.url;
      Vue.set(this.tenant.businessPhoto,)

    },
    handleRemove4(response, file) {
      // 上传成功后，显示上传按钮
      this.upload_btn4 = false;
    },
    handleDelete2(index) {
      this.table_area.splice(index, 1);
    },
    handleDelete(index) {
      this.table_type.splice(index, 1);
    },

    // 第一个  表格
    formatter(row, column) {
      return row.isNeedReturn == 1 ? '是' : '否'
    },
    formatter1(row, column) {
      return row.isCheck == 1 ? '是' : '否'
    },
    formatter2(row, column) {
      return row.isPast == 1 ? '是' : '否'
    },
    formatter3(row, column) {
      if (row.afterFlow == 1) {
        return "必访"
      } else if (row.afterFlow == 2) {
        return '申诉'
      } else if (row.afterFlow == 3) {
        return '挂起'
      } else if (row.afterFlow == 4) {
        return '重新完工'
      } else if (row.afterFlow == 9) {
        return '关闭'
      }

    },
    // 卡片事件
    //点击查看图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
      // console.log(fileList, "已上传文件")
    },
    // 上传发生变化钩子
    // 注意 :on-remove="handleimageChange"与:on-change="handleimageChange" 都绑定这个方法，这样无论是上传图片还是移除图片，都会更新图片数据列表
    handleimageChange(file, fileList) {
      this.upload_img = fileList;
      // this.upload_img.imageName=fileList.name;
      console.log(fileList, "文件状态改变时")
      console.log(file, "文件状态改变时file")
    },
    //工单
    showPreconditionDialogFunc() {
      this.showOrderPop = true
    },
    //工单
    showProfileDialogFunc() {
      this.showProfilePop = true
    },
    showAssetDialogFunc(){
      this.showAssetPop = true
    },
    doCheck(){
      this.showCheckDialog = true;
    },
    checkCommit(type){
      this.showCheckDialog = false;
      this.getData();
    },
  },
};
</script>
<style lang="scss" scoped>
#containt .detail-wrap .d-header {
  margin: -6px 0px 0 -12px !important;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
}

.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.header_dialog {
  border-radius: 8px !important;
  height: 800px !important;
}

el-dialog {
  border-radius: 8px !important;
  box-shadow: 0 0 24px rgb(0 0 0 / 22%) !important;
}

v::deep .el-upload .el-upload--picture-card {
  position: relative;
  left: -200px;
}

// 单选框
.radio_item {
  width: 24%;
  margin-top: 10px;
  margin-bottom: 10px !important;

  >span {
    display: inline-block;
    width: 120px;
    margin-right: 13px;
    text-align: right;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }
}

.firm {
  .el-input {
    width: 150px;
  }
}

.type_title {
  font-weight: 400;
  text-align: right;
  width: 112px;
  position: relative;
  padding: 0 10px 0 4px;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

.type_select {
  width: 120px;
  text-align: center;
}

.type_brand {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  >div {
    margin: 16px 0;
    width: 25%;
  }
}

// 备注的样式
.annotate {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

.el-textarea__inner {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

// 装图片的  大框
::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

::v-deep.el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none !important;
}

// 输入框的宽度
// #containt .table-detail tbody tr td .el-input {
//   width: 100% !important;
//   width: 0 !important;
// }

// Switch 开关  标题的宽度
.el-switch__label * {
  line-height: 1;
  width: 160px !important;
  display: inline-block;
  font-weight: 400;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

// 清楚表格 默认padding
.el-table--medium .el-table__cell {
  padding: 0px 0 !important;
}

.table_item {
  .el-table__row:hover>td {
    background-color: #D4E7FF !important;
  }
}

.pic_item {

  .el-upload--picture-card {
    margin-top: 1px;
    width: 36px !important;
    height: 36px !important;
    line-height: 46px !important;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

.papers {
  margin-left: 30px;
  position: absolute;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

.btn_zdy {
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 0 0px !important;
}

// 步骤条
::v-deep .el-card__body,
.el-main {
  padding: 0px !important;
  font-size: 12px;
}

.task {
  color: #62f382;
}

.card {
  padding: 0px 5px;
  background-color: #efefef;
}

.el-timeline {
  margin-top: 40px;
  margin: 0;
  list-style: none;
  margin-left: 6px;
  border: 1px solid #fbfbfb;
  padding-top: 12px;
  height: 380px;
  overflow-y: scroll;
  background-color: #f2f2f2;
  padding-left: 10px !important;
}

.title_icon1 {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #409EFF;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

.title_icon {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #00c4b3;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}



.bread {
  span {
    color: rgba(86, 86, 86, 0.96) !important;
  }

  ::v-deep .el-collapse-item__content {
    padding-bottom: 0px;
    background-color: #efefef;

  }
}

.card_bread {
  position: relative !important;
}

::v-deep .el-tabs__content {
  overflow: visible !important;

}

#containt .detail-wrap .d-cont {
  overflow: unset !important;
}

// .el-timeline-item {
//   position: relative;
//   padding-bottom: 0px !important;
//   margin-left: 47px;
// }
.el-timeline-item[data-v-2cf56cc1] {
  position: relative;
  margin-left: 5px;
  padding-bottom: 0px !important;
}

// 滚动条样式

/* 滚动条 */
::-webkit-scrollbar {
  width: 5px;
  height: 12px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 0px;
  // background: rgba(224, 7, 7, 0.05);
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 00px;
  background: #cfcece;
}

// 步骤条 圆的位置
::v-deep .el-timeline-item__node--normal {
  left: 0px !important;
  width: 12px;
  height: 12px;
}

.el-timeline[data-v-2cf56cc1] {
  position: relative !important;
}

#containt .detail-wrap .d-cont .d-item {
  border: solid 1px #e9e9e9;
  padding: 0 12px 6px;
  position: relative !important;
}

::v-deep .el-collapse-item__arrow {
  position: absolute !important;
  top: 12px !important;
  right: 0 !important;
  font-size: 18px;
  color: #00c4b3 !important;
}

::v-deep .el-collapse-item__content {
  padding-bottom: 0px !important;
}

// 本单费用位置
.expense {
  position: absolute;
  right: 20%;
  margin-top: 5px;
  color: #00c4b3;
  font-size: 13px;
}



.pic_main {
  display: flex;
  margin-left: 75px;
  margin-top: 10px;

  .pic_item {
    display: flex;
    margin-right: 40px;

    span {
      line-height: 60px;
      font-size: 12px;
      color: rgba(86, 86, 86, 0.96);
      font-weight: 400;

    }
  }
}

// 步骤条
.el-steps--simple {
  margin: 20px 0 6px;
}

.el-step.is-simple {
  width: 225px;
}

.audit {
  span {
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
    font-weight: 400;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

// 折叠样式对其
// .table-detail {
//   tr{
//     display:block;
//   }
// }
#containt .table-detail tbody tr th {
  display: table-cell;
  vertical-align: middle;
}

#containt .table-detail tbody tr td {

  display: table-cell;
  vertical-align: middle;
}

.title_time {
  margin-top: -13px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .span1 {
    color: #00c4b3 !important;
    width: 35%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .span2 {
    margin-right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

}


// 字段之间的距离
#containt .table-detail tbody tr td {
  padding: 5px 12px;
  width: 172.2px;
  height: 27.2px !important;
  word-break: break-word;
}

.information {
  padding: 4px 10px;
  background-color: #E1F2FF;
  color: #268AEA;
  border-radius: 3px;
  margin: 0 5px;
}





::v-deep .el-step__title {
  font-size: 11px;
  line-height: 25px;
}



#containt .table-detail tbody tr td[data-v-7297c694] {
  padding: 5px 12px;
  width: 11vw !important;
  height: 27.2px !important;
  word-break: break-word;
}
</style>
